import { DEFAULT_USER_NAME } from '@jebel/constants';
/**
 * Formats the user's name based on the provided input.
 *
 * @param user - The user object containing name information. It can be of type `FormatUserNameInput`, `undefined`, or `null`.
 * @param fallback - An optional fallback string to use if the user's first and last names are not available.
 * @returns The formatted user name. If `user.fullName` is provided, it returns that. Otherwise, it concatenates `firstName` and `lastName`. If neither is available, it returns the fallback or a default user name.
 */
export function formatUserName(user, fallback) {
    var _a, _b, _c;
    if (fallback === void 0) { fallback = (_a = user === null || user === void 0 ? void 0 : user.email) !== null && _a !== void 0 ? _a : DEFAULT_USER_NAME; }
    const firstName = (_b = user === null || user === void 0 ? void 0 : user.firstName) !== null && _b !== void 0 ? _b : '';
    const lastName = (_c = user === null || user === void 0 ? void 0 : user.lastName) !== null && _c !== void 0 ? _c : '';
    if (user === null || user === void 0 ? void 0 : user.fullName) {
        return user.fullName;
    }
    if (!firstName || !lastName) {
        return fallback;
    }
    return `${firstName} ${lastName}`;
}
